import {Converter, PaymentDetails} from '@spartacus/core';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DcpPaymentDetailsSerializer implements Converter<PaymentDetails, any> {

  convert(source: PaymentDetails, target: any = {}): any {
    if (source.dpaoSubscriptionId) {
      return target.dpaoSubscriptionId = source.dpaoSubscriptionId;
    }
    return target;
  }

}
